import { DockLocation } from "./DockLocation"
import { FlexLayoutNode } from "./model/FlexLayoutNode"
import { IDropTarget } from "./model/IDropTarget"
import { Rect } from "./Rect"

export class DropInfo {
  node: FlexLayoutNode & IDropTarget
  rect: Rect
  location: DockLocation
  index: number
  className: string

  constructor(node: FlexLayoutNode & IDropTarget, rect: Rect, location: DockLocation, index: number, className: string) {
    this.node = node
    this.rect = rect
    this.location = location
    this.index = index
    this.className = className
  }
}



// WEBPACK FOOTER //
// ./src/stores/catalog/flexLayout/flexlayout-react/src/DropInfo.ts